import Enum from './enum'

class TemplateType extends Enum
{
  constructor(value) {
    super(value);
  }
}

TemplateType.init({
  INVITE_TO_TENDER: "InviteToTender",
  PROTOCOL_GETTING_REQUEST: "ProtocolGettingRequest",
  PROTOCOL_GETTING_REQUEST_REDUCTION: "ProtocolGettingRequestReduction",
  PROTOCOL_PROCESSING_REQUEST: "ProtocolProcessingRequest",
  SHORT_GETTING_REQUEST: "ShortGettingRequest",
  DECLINE_REQUEST: "DelcineRequest",
  CONDITION_APPROVE_REQUEST: "ConditionApproveRequest",
  PROTOCOL_RETEND: "ProtocolRetend",
  BLOCK_MESSAGE: "BlockMessage",
  INVITE_TO_RETEND: "InviteToRetend",
  SHORT_ACCEPT_NOT_WINNER: "ShortAcceptNotWinner",
  SHORT_ACCEPT_WINNER: "ShortAcceptWinner",
  REPORT_ECONOMY: "ReportEconomy",
  SPECIFICATION_TEMPLATE: "SpecificationTemplate",
  LOT_SPECIFICATION: "LotSpecification",
  REPORT_STEP_SUMMARY: "ReportStepSummary",
  ACCREDITATION: "Accreditation",
  REPORT_SUMMARY: "ReportSummary",
  REPORT_PRICE: "ReportPrice",
  REGLAMENT: "Reglament",
  AGREEMENT: "Soglashenie",
  GUIDE: "Instruction",
  DIGITAL_SIGNATURE: "Ep",
  ACCEPT_BID: "AcceptBid",
  PROTOCOL_ACCEPT: "ProtocolAccept",
}, {
  INVITE_TO_TENDER: 'template-type.invite-to-tender',
  PROTOCOL_GETTING_REQUEST: 'template-type.protocol-getting-request',
  PROTOCOL_GETTING_REQUEST_REDUCTION: 'template-type.protocol-getting-request-reduction',
  PROTOCOL_PROCESSING_REQUEST: 'template-type.protocol-processing-request',
  SHORT_GETTING_REQUEST: 'template-type.short-getting-request',
  DECLINE_REQUEST: 'template-type.decline-request',
  CONDITION_APPROVE_REQUEST: 'template-type.condition-approve-request',
  PROTOCOL_RETEND: 'template-type.protocol-retend',
  BLOCK_MESSAGE: 'template-type.block-message',
  INVITE_TO_RETEND: 'template-type.invite-to-retend',
  SHORT_ACCEPT_NOT_WINNER: 'template-type.short-accept-not-winner',
  SHORT_ACCEPT_WINNER: 'template-type.short-accept-winner',
  REPORT_ECONOMY: 'template-type.report-economy',
  SPECIFICATION_TEMPLATE: 'template-type.specification-template',
  LOT_SPECIFICATION: 'template-type.lot-specification',
  REPORT_STEP_SUMMARY: 'template-type.report-step-summary',
  ACCREDITATION: 'template-type.accreditation',
  REPORT_SUMMARY: 'template-type.report-summary',
  REPORT_PRICE: 'template-type.report-price',
  REGLAMENT: 'template-type.reglament',
  AGREEMENT: 'template-type.agreement',
  GUIDE: 'template-type.guide',
  DIGITAL_SIGNATURE: 'template-type.digital-signature',
  ACCEPT_BID: 'template-type.accept-bid',
  PROTOCOL_ACCEPT: 'template-type.protocol-accept'
});

TemplateType.Groups = {
  printable: [
    'INVITE_TO_TENDER',
    'PROTOCOL_GETTING_REQUEST',
    'PROTOCOL_GETTING_REQUEST_REDUCTION',
    'PROTOCOL_PROCESSING_REQUEST',
    'SHORT_GETTING_REQUEST',
    'DECLINE_REQUEST',
    'CONDITION_APPROVE_REQUEST',
    'PROTOCOL_RETEND',
    'BLOCK_MESSAGE',
    'INVITE_TO_RETEND',
    'SHORT_ACCEPT_NOT_WINNER',
    'SHORT_ACCEPT_WINNER',
    'REPORT_ECONOMY',
    'SPECIFICATION_TEMPLATE',
    'REPORT_STEP_SUMMARY',
    'ACCREDITATION',
    'REPORT_SUMMARY',
    'REPORT_PRICE',
    'ACCEPT_BID',
    'PROTOCOL_ACCEPT'
  ],
  messages: [
    "REGLAMENT",
    "AGREEMENT",
    "GUIDE",
    "DIGITAL_SIGNATURE",
  ]
};

export default TemplateType;
